import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SelectivePreloadStrategy} from './selective-preload.strategy';

const appRoutes: Routes = [
  // {path: 'company', loadChildren: () => import('./company/company.module').then(m => m.CompanyModule)},
  {path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)},
  {path: '', pathMatch: 'full', redirectTo: 'admin'},
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {preloadingStrategy: SelectivePreloadStrategy}),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
